<p-tabView>
    <p-tabPanel header="Theoretical vs Actual" fxLayout="column">
        <div #chartwrapper class="chartwrapper liquitics-box ladder-chart" fxFlex="1 0 auto">
            <!-- <p-progressSpinner *ngIf="selectedRiskGraphicalConfig && !chartReady" class="spinner" animationDuration="2s"></p-progressSpinner> -->
            <div id="intradayladderchartdiv" class="chartdiv"></div>
        </div>
    </p-tabPanel>
    <p-tabPanel header="Account Breakdown">
        <mat-button-toggle-group #breakdownTypeGroup="matButtonToggleGroup" (change)="onBreakDownTypeClicked($event)" [vertical]="false">
            <mat-button-toggle class="" value="expectedactual" [checked]="breakdownType === 'expectedactual'" matTooltip="Show Expected and Actual"
                matTooltipPosition="below">
                <span class="fa fa-arrows-h"></span>
            </mat-button-toggle>
            <mat-button-toggle class="" value="percent" [checked]="breakdownType === 'percent'" matTooltip="Show % Complete" matTooltipPosition="below">
                <span class="fa fa-percent"></span>
            </mat-button-toggle>
            <!-- <mat-button-toggle class="" value="heat" [checked]="survivalHorizonViewMode == 'heat'" matTooltip="Show as Heatmap" matTooltipPosition="below">
                <span class="fa fa-thermometer"></span>
            </mat-button-toggle> -->
        </mat-button-toggle-group>
        <!-- <p-dataTable [value]="tableData">
            <p-column field="account" header="Account" [style]="{'width':'20%','text-align':'center'}" styleClass="col-account"></p-column>
            <p-column *ngFor="let col of columns" [field]="col.field" [header]="col.header" [style]="{'text-align':'center'}">
                <ng-template let-row let-col let-entry="rowData" pTemplate="body" styleClass="test">
                    <div *ngIf="breakdownType === 'expectedactual'">
                        <span class="expected-value">{{ expectedValue(entry[col.field]) }}</span>
                        <span *ngIf="entry[col.field]" class="fa fa-long-arrow-right"></span>
                        <span class="actual-value">{{ actualValue(entry[col.field]) }}</span>
                    </div>
                    <div *ngIf="breakdownType === 'percent'">
                        <span class="expected-value">{{ entry[col.field+'_percent'] | percent }}</span>
                    </div>
                    <div *ngIf="breakdownType === 'heat'">
                    </div>
                </ng-template>
            </p-column>
        </p-dataTable> -->
    </p-tabPanel>
</p-tabView>